import { createFileRoute } from '@tanstack/react-router';
import { DomainsTab } from '@/components/health-readiness/domains-tab';

/** Health & Readiness → Domains, one domain open (T-0242). */
export const Route = createFileRoute(
  '/engagements/$engagementId/health-readiness/domains/$domainId',
)({
  component: DomainRoute,
});

function DomainRoute() {
  const { engagementId, domainId } = Route.useParams();
  return <DomainsTab engagementId={engagementId} domainId={domainId} />;
}
